import 'slick-carousel-latest';
export default (($) => {
    console.log('UNTUCKit : Module : Ambassadors : loaded');
    const $dom = {};
    const allowSlide = true;
    const cacheDom = () => {
        $dom.hoverEl = $('.js-hover');
        $dom.slider = $('.js-ambassador-slider');
        $dom.sliderButton = $('.js-ambassadors-mobile-btn');
    };
    const hover = (event) => {
        if (allowSlide) {
            const $target = $(event.currentTarget);
            setSlide($target);
        }
    };
    const navigateMobileSlider = (event) => {
        const $target = $(event.currentTarget);
        const direction = $target.attr('data-direction');
        if (direction == 'next') {
            $dom.slider.slick('slickNext');
        }
        else {
            $dom.slider.slick('slickPrev');
        }
    };
    const bindUIActions = () => {
        $dom.hoverEl.on('mouseover', hover);
        $dom.sliderButton.on('click', navigateMobileSlider);
    };
    const init = () => {
        console.log('UNTUCKit : Module : Ambassadors : init');
        cacheDom();
        bindUIActions();
        setInitial();
    };
    const setInitial = () => {
        const param = new URLSearchParams(window.location.search).get('ambassador');
        if (param) {
            const $target = $(`.js-hover[data-ambassador="${param.toLowerCase()}"]`);
            if ($target.length) {
                setSlide($target);
                scrollToAmbassadors();
            }
        }
    };
    const setSlide = ($target) => {
        const slideIndex = $target.attr('data-index');
        $dom.slider.slick('slickGoTo', slideIndex, true);
        $target.siblings().removeClass('is-active');
        $target.addClass('is-active');
    };
    const scrollToAmbassadors = () => {
        const $ambassadorsSection = $('.js-ambassadors');
        const $header = $('.js-header');
        window.scrollTo(0, $ambassadorsSection.offset().top - $header.height());
    };
    return { init };
})($);
